import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Charge/BanksList', method: 'GET', body: null, token: token })
}
